jQuery(document).ready(function() {

    jQuery('[data-youtube], [data-vbg]').youtube_background();
    /*document.querySelector('#ytbg2').addEventListener('video-background-play', function(){
        $(".thumb-image").hide();
    });*/
});

$(".bg-video > div").on("click",function(e){

    if(!$(e.target).hasClass("home-video-play-button") && !$(e.target).hasClass("fa-pause-circle")){

       if(!$(".home-video-play-button").hasClass("paused")){
           $( ".home-video-play-button" ).trigger( "click" );
       }
    }

});


$('.variant-box__description-title').click(function(){

    $('.variant-box__description-content').slideToggle()
    $(this).toggleClass('active')
})






/*$('.featured-slider__content').slick({
    slidesToShow: 2,
    variableWidth:true,
    autoplay: false,
    autoplaySpeed: 2000,

    infinite: false,
    prevArrow: $('.featured-slider__prev'),
    nextArrow: $('.featured-slider__next'),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          variableWidth: true,
          arrows: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  })*/
